import Home from "../views/home";
export default [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    component: () => import(/* webpackChunkName: "about" */ "../views/about"),
  },
  {
    path: "/career",
    name: "career",
    component: () => import(/* webpackChunkName: "career" */ "../views/career"),
    // redirect: "/career/work",
    children: [
      {
        path: "vacancy",
        name: "vacancy",
        component: () =>
          import(/* webpackChunkName: "vacancy" */ "../views/vacancy"),
      },
      {
        path: "work",
        name: "work",
        component: () => import(/* webpackChunkName: "work" */ "../views/work"),
      },
    ],
  },
  {
    path: "/services",
    name: "services",
    component: () =>
      import(/* webpackChunkName: "services" */ "../views/services"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/contact"),
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import(/* webpackChunkName: "faq" */ "../views/faq"),
  },
  {
    path: "/get-employee",
    name: "get-employee",
    component: () =>
      import(/* webpackChunkName: "get-employee" */ "../views/get-employee"),
    meta: { redirect: "other" },
  },
  {
    path: "/partners",
    name: "partners",
    component: () =>
      import(/* webpackChunkName: "partners" */ "../views/partners"),
  },
  {
    path: "/nurses",
    name: "nurses",
    component: () =>
      import(/* webpackChunkName: "nurses" */ "../views/nurses"),
  },
  {
    path: "/legal",
    name: "legal",
    component: () => import("../views/legal"),
  },
  {
    path: "/terms-of-services",
    name: "terms-of-services",
    component: () => import("../views/terms-of-services"),
  },
  {
    path: "/impressum",
    name: "impressum",
    component: () => import("../views/impressum"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ "../views/login"),
    meta: { guestOnly: true, headerSpacing: true },
  },
  {
    path: "/login/clinic",
    name: "login-clinic",
    redirect: { name: "login" },
  },
  {
    path: "/login/nurse",
    name: "login-nurse",
    redirect: { name: "login" },
  },
  {
    path: "/register/clinic",
    name: "register-clinic",
    component: () => import(/* webpackChunkName: "register-clinic" */ "../views/register-clinic"),
    meta: { guestOnly: true },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import(/* webpackChunkName: "forgot-password" */ "../views/forgot-password"),
    meta: { guestOnly: true, headerSpacing: true },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import(/* webpackChunkName: "reset-password" */ "../views/reset-password"),
    meta: { guestOnly: true, headerSpacing: true },
  },
  {
    path: "/register/nurse",
    name: "register-nurse",
    component: () => import(/* webpackChunkName: "register-nurse" */ "../views/register-nurse"),
    meta: { guestOnly: true },
  },
  {
    path: "/profile/nurse",
    name: "profile-nurse",
    component: () => import(/* webpackChunkName: "profile-nurse" */ "../views/profile-nurse"),
    meta: { requiresRole: "Nurse", headerSpacing: true },
  },
  {
    path: "/candidates",
    name: "candidates",
    component: () => import(/* webpackChunkName: "candidates" */ "../views/candidates"),
    meta: { requiresRole: "Clinic", headerSpacing: true },
  },
  {
    path: "/candidates/:id",
    name: "candidate-detail",
    component: () => import(/* webpackChunkName: "candidate-detail" */ "../views/candidate-detail"),
    meta: { requiresRole: "Clinic", headerSpacing: true },
  },
  {
    path: "/my-applications",
    name: "my-applications",
    component: () => import(/* webpackChunkName: "my-applications" */ "../views/my-applications"),
    meta: { requiresRole: "Clinic", headerSpacing: true },
  },
  {
    path: "/clinic-dashboard",
    name: "clinic-dashboard",
    component: () => import(/* webpackChunkName: "clinic-dashboard" */ "../views/clinic-dashboard"),
    meta: { requiresRole: "Clinic", headerSpacing: true },
  },
  {
    path: "/nachrichten",
    name: "clinic-nachrichten",
    component: () => import(/* webpackChunkName: "clinic-nachrichten" */ "../views/clinic-nachrichten"),
    meta: { requiresRole: "Clinic", headerSpacing: true },
  },
  {
    path: "/clinic-settings",
    name: "clinic-settings",
    component: () => import(/* webpackChunkName: "clinic-settings" */ "../views/clinic-settings"),
    meta: { requiresRole: "Clinic", headerSpacing: true },
  },
  // Dynamic page — admin tərəfdən yaradılmış istənilən path üçün catch-all.
  // Mövcud spesifik route-lardan SONRA gəlir, ona görə onları sındırmır.
  {
    path: "/:slug",
    name: "dynamic-page",
    component: () =>
      import(/* webpackChunkName: "dynamic-page" */ "../views/dynamic-page"),
  },
  {
    path: "*",
    redirect: "/",
  },
];
